import React from "react";

 
import Navbar from "../components/homepage/Navbar";
import PrivacyPolicyHero from "../components/privacyPolicy/PrivacyPolicyHero";
import PrivacyPolicyDetails from "../components/privacyPolicy/PrivacyPolicyDetails";
import { Header, Footer } from "../shared";

const PrivacyPolicyPage = () => {
  window.scrollTo(0, 0);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      <PrivacyPolicyHero />
      <PrivacyPolicyDetails />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
